module.exports = __webpack_public_path__ + "media/images/heathered_small-e897bae0.gif";